import { render, staticRenderFns } from "./Bien.vue?vue&type=template&id=ba6f39c6&scoped=true&"
import script from "./Bien.vue?vue&type=script&lang=js&"
export * from "./Bien.vue?vue&type=script&lang=js&"
import style0 from "./Bien.vue?vue&type=style&index=0&id=ba6f39c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6f39c6",
  null
  
)

export default component.exports